import api from "./api";

export const createDispute = async ({ ledgerTransactionId, lineItems, reason, details }) => {
  return api.post("/api/disputes", { ledgerTransactionId, lineItems, reason, details }, { bypassInterceptor: true });
};
